import { useState } from 'react';
import {
  Box,
  ButtonBase,
} from '@mui/material';
import VideoPlayer from './VideoPlayer';
import { filterUndefined } from '../../../utils/FilterUndefinedObject';

export default function WatchQuickVideo({
  ...props
}) {
  const defaultProps = {
    videoUrl: null,
  };
  const {
    videoUrl,
  } = { ...defaultProps, ...filterUndefined(props) };
  const [openVideo, setOpenVideo] = useState(false);

  if (!videoUrl) {
    return null;
  }
  return (
    <>
      <Box alignSelf='center'>
        <ButtonBase
          onClick={() => { setOpenVideo(true); }}
          className='btn-link'
        >
          Watch a Quick Help Video
        </ButtonBase>
      </Box>
      <VideoPlayer
        videoUrl={videoUrl}
        open={openVideo}
        handleClose={() => { setOpenVideo(false); }}
      />
    </>
  );
}
